module.exports = __webpack_public_path__ + "img/1125-joy-kirakira.715a4687.png";